import React, { useState, useEffect } from 'react';
import { blocksApi } from '../services/blocksApi';
import toast from 'react-hot-toast';
import './BlockContent.css';
import Loading from './common/Loading';

const BlockContent = ({ identifier, className = '', fallback = null }) => {
  const [block, setBlock] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlock = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Get all blocks and find the one with matching identifier
        const block = await blocksApi.getBlockByIdentifier(identifier);

        if (block) {
          setBlock(block);
        } else {
          setError('Block not found or inactive');
        }
      } catch (err) {
        console.error('Error fetching block:', err);
        setError('Failed to load block content');
      } finally {
        setLoading(false);
      }
    };

    if (identifier) {
      fetchBlock();
    } else {
      setLoading(false);
      setError('No identifier provided');
    }
  }, [identifier]);

  // Loading state
  if (loading) {
    return (
      <Loading />
    );
  }

  // Error state
  if (error) {
    if (fallback) {
      return <div className={`block-content-fallback ${className}`}>{fallback}</div>;
    }
    return (
      <div className={`block-content-error ${className}`}>
        <span>Content not available</span>
      </div>
    );
  }

  // No block found
  if (!block) {
    if (fallback) {
      return <div className={`block-content-fallback ${className}`}>{fallback}</div>;
    }
    return null;
  }

  // Render block content
  return (
    <div 
      className={`block-content ${className}`}
      dangerouslySetInnerHTML={{ __html: block.content }}
    />
  );
};

export default BlockContent;
